<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    offset-y
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        depressed
        color="primary"
        class="rounded-tag-small normal-btn-text"
        v-on="on"
        @click.stop.prevent=""
      >
        <span v-if="!isCustomDate">{{ state.description }}</span>
        <span v-else>{{ state.initialDate | date }} até {{ state.finalDate | date }}</span>
        <v-icon color="white">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-row no-gutters>
        <v-col cols="12" sm="4">
          <v-list class="ma-3">
            <v-list-item v-for="month in defaultRangeOptions"
                         :key="month.description"
                         @click="selectDefaultRange(month)">
              <v-list-item-content :class="month.selected ? 'text--primary--color' : ''">
                {{ month.description }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" sm="8">
          <v-card outlined tile class="pa-5 fill-height">
            <h3>Personalizar período</h3>
            <div class="mt-3">
              <px-date-picker label="Data inicial"
                              dense
                              clearable
                              input-class="rounded-card required"
                              v-model="customInitialDate"/>
            </div>
            <div class="mt-3">
              <px-date-picker label="Data final"
                              dense
                              clearable
                              input-class="rounded-card required"
                              v-model="customFinalDate"/>
            </div>
            <div class="mt-3 text-right">
              <v-btn depressed
                     class="rounded-tag-small normal-btn-text"
                     color="primary"
                     :disabled="$v.$invalid"
                     @click="onClickApply">
                Aplicar
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import {
  buildRangeThisMonth,
  buildRangeThisWeek,
  buildRangeToday,
  buildRangeLastMonth,
} from './date-range-builder';

export default {
  props: {
    initialDateSelection: Object,
  },
  data() {
    return {
      menuOpened: false,
      customInitialDate: null,
      customFinalDate: null,
      defaultRangeOptions: [],
      state: null,
    };
  },
  computed: {
    isCustomDate() {
      return this.state && this.state.key === 'CUSTOM_DATE';
    },
  },
  methods: {
    emitChange() {
      this.$emit('change', this.state);
    },
    selectDefaultRange(defaultRange) {
      this.selectKey(defaultRange.key);
      this.emitChange();
      this.menuOpened = false;
    },
    selectKey(key) {
      this.defaultRangeOptions = this.defaultRangeOptions
        .map((option) => {
          const toReturn = { ...option, selected: false };
          if (option.key === key) {
            this.state = option;
            toReturn.selected = true;
          }
          return toReturn;
        });
    },
    clearDefaultRangeKeys() {
      this.defaultRangeOptions = this.defaultRangeOptions
        .map((option) => ({ ...option, selected: false }));
    },
    buildDefaultRanges() {
      this.defaultRangeOptions = [
        {
          description: 'Hoje',
          key: 'TODAY',
          selected: false,
          ...buildRangeToday(),
        },
        {
          description: 'Esta semana',
          key: 'CURRENT_WEEK',
          selected: false,
          ...buildRangeThisWeek(),
        },
        {
          description: 'Este mês',
          key: 'CURRENT_MONTH',
          selected: false,
          ...buildRangeThisMonth(),
        },
        {
          description: 'Mês passado',
          key: 'LAST_MONTH',
          selected: false,
          ...buildRangeLastMonth(),
        },
      ];
    },
    onClickApply() {
      this.clearDefaultRangeKeys();
      this.state = {
        description: '',
        key: 'CUSTOM_DATE',
        initialDate: this.customInitialDate,
        finalDate: this.customFinalDate,
      };
      this.menuOpened = false;
      this.emitChange();
    },
    setInitialDateSelection() {
      if (this.initialDateSelection.key === 'CUSTOM_DATE') {
        this.clearDefaultRangeKeys();
        this.state = this.initialDateSelection;
        this.customInitialDate = this.initialDateSelection.initialDate;
        this.customFinalDate = this.initialDateSelection.finalDate;
        this.emitChange();
        return;
      }

      this.selectKey(this.initialDateSelection.key);
      this.emitChange();
    },
  },
  created() {
    this.buildDefaultRanges();

    if (this.initialDateSelection) {
      this.setInitialDateSelection();
      return;
    }

    if (!this.state) {
      this.selectKey('CURRENT_MONTH');
      this.emitChange();
    }
  },
  validations: {
    customInitialDate: {
      required,
    },
    customFinalDate: {
      required,
    },
  },
};
</script>

<style scoped>

</style>
